import React from 'react';
import { Link } from 'react-router-dom';
import {
  Car, Shield, Zap, FileText, Clock, TrendingUp, Users, Briefcase,
  Home, Heart, Gift, RefreshCw, ArrowUpCircle, Lightbulb, Star, Phone, Mail,
  MapPin, AlertTriangle, Headphones, Building, DollarSign, Percent, Calendar,
  CreditCard, Smartphone, Award, ThumbsUp, Handshake, BookOpen, Globe, Lock,
  CheckCircle, HelpCircle, DollarSign as MoneyIcon
} from 'lucide-react';

const UsedCarLoanChandauli = () => {
  return (
    <div className="bg-gray-50">
      {/* Hero Banner */}
      <div className="relative bg-gradient-to-r from-green-800 to-green-700 text-white py-12 md:py-16 overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 animate-fade-in-up">
                Used Car Loan in Chandauli
              </h1>
              <p className="text-lg md:text-xl mb-6 animate-fade-in-up animation-delay-200">
                Own a pre‑owned car with low interest, quick approval, and minimal paperwork.
              </p>
              <div className="flex flex-wrap gap-4 justify-center lg:justify-start animate-fade-in-up animation-delay-400">
                <button className="bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-semibold px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg">
                  Apply Now
                </button>
                <button className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-semibold px-6 py-2 rounded-full transition-all duration-300">
                  Check Eligibility
                </button>
              </div>
            </div>
            <div className="flex justify-center lg:justify-end">
              <img
                src="https://tse3.mm.bing.net/th/id/OIP.d6cvxpb1QZdp8yb7r8wtLgHaEK?rs=1&pid=ImgDetMain&o=7&rm=3"
                alt="Used Car"
                className="max-w-full h-auto rounded-2xl shadow-xl transition-transform duration-500 hover:scale-105"
              />
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-12">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="white"></path>
          </svg>
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* About Used Car Loan */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">Used Car Loan</h2>
          <div className="bg-white rounded-xl shadow-md p-8">
            <p className="text-gray-700 leading-relaxed">
              Maintaining a good life standard can be an expensive affair. And hitting the road with your own vehicle is one of the most important milestones of this.  CashPro Financial Services, India’s leading financial institution, is here with a low‑interest used car loan in Chandauli that can help you in owning a vehicle of your own and saving some bucks at the same time.
            </p>
            <div className="text-center mt-6">
              <button className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-full">Apply now</button>
            </div>
          </div>
        </div>

        {/* Features & Benefits */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-green-700 mb-8 text-center">Features & Benefits</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: Percent, title: "Full On‑road Funding", desc: "Loan covers the entire price of the used car." },
              { icon: Zap, title: "Guaranteed Approval", desc: "Better approval rate than new car loans." },
              { icon: Shield, title: "RC Transfer Covered", desc: "Seamless ownership transfer included." },
              { icon: TrendingUp, title: "Low Interest Rates", desc: "Much lower than personal loans or credit cards." },
              { icon: Clock, title: "Flexible Tenure", desc: "Repayment period up to 5 years." },
              { icon: Award, title: "Certified Cars", desc: "Choose from certified pre‑owned vehicles." }
            ].map((item, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <item.icon className="w-10 h-10 text-green-600 mb-4" />
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Why Buy Used Car */}
        <div className="mb-16 bg-white rounded-xl shadow-md p-8">
          <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">Why Buy a Used Car?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              "Save money – used cars are more affordable.",
              "Dodge scratches and learner’s driving without worry.",
              "Easier and cheaper insurance.",
              "Certified second‑hand cars available."
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 mt-1" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Documents Required */}
        <div className="mb-16 bg-white rounded-xl shadow-md p-8">
          <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">Documents Required</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              "Identity Proof (Aadhaar, PAN, Voter ID, Passport, Driving License)",
              "Address Proof (Aadhaar, Utility bills, Passport)",
              "Income Proof (Salaried): Salary slips (last 3 months), Bank statement (6 months), Form 16",
              "Income Proof (Self‑employed): ITR (last 2 years), Profit & Loss statement, Bank statement",
              "Used car details: RC copy, insurance copy, invoice"
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <FileText className="w-5 h-5 text-green-600 mt-1" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Eligibility */}
        <div className="mb-16 bg-white rounded-xl shadow-md p-8">
          <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">Used Car Loan Eligibility</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              "Age: 21 – 65 years",
              "Minimum income: ₹20,000 per month",
              "At least 1 year of job experience (salaried) or 3 years business vintage",
              "Good credit score (CIBIL 700+)"
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 mt-1" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="mb-16 bg-white rounded-xl shadow-md p-8">
          <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {[
              { q: "What are the benefits of applying through  CashPro Financial Services?", a: "Lowest interest rates, zero fees, free doorstep service, quick disbursal." },
              { q: "How can I benefit from getting my loan approved before finalizing my car?", a: "You get a pre‑approved budget, making negotiations easier and faster." },
              { q: "How much loan can I get on a used car?", a: "Up to 90% of the car's valuation, depending on your profile." },
              { q: "Do I need to go to the bank to complete documentation?", a: "No, we offer doorstep document collection and video KYC." },
              { q: "What is the process of transfer of ownership after my loan is sanctioned?", a: "We assist with RC transfer; the process is seamless and handled by our team." }
            ].map((item, idx) => (
              <div key={idx} className="border-b border-gray-200 pb-3">
                <div className="flex items-start gap-3">
                  <HelpCircle className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">{item.q}</h3>
                    <p className="text-gray-600">{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Help Section */}
        <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
          <h2 className="text-3xl font-bold text-green-700 mb-4">We Are Here to Help You</h2>
          <p className="text-gray-600 mb-6">Our used car loan experts are ready to assist you.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div>
              <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-full">Apply Now</button>
            </div>
            <div>
              <a href="tel:+918887141052" className="text-lg font-bold text-green-600">+91 88871 41052</a>
            </div>
            <div>
              <a href="mailto:info@cashpro.co.in" className="text-lg font-bold text-green-600">info@cashpro.co.in</a>
            </div>
          </div>
          <Link to="/contact" className="text-green-600 hover:underline font-medium">Contact Us →</Link>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-up { animation: fade-up 0.6s ease-out forwards; }
        .animate-fade-in-up { animation: fade-up 0.6s ease-out forwards; }
        .animation-delay-200 { animation-delay: 0.2s; }
        .animation-delay-400 { animation-delay: 0.4s; }
      `}</style>
    </div>
  );
};

export default UsedCarLoanChandauli;